import { createFeatureSelector, createSelector } from '@ngrx/store';
import { Language } from '../../models/language.model';


export const selectLanguages = createFeatureSelector<readonly Language[]>('languages');

export const selectAllLanguages = createSelector(
  selectLanguages,
  (languages: readonly Language[]) => languages ?? []
);

export const selectLanguageById = (languagesId: number) => createSelector(
  selectLanguages,
  (languages: readonly Language[]) => languages?.find(language => language.id === languagesId)
);

export const selectLanguagesCount = createSelector(
  selectLanguages,
  (languages: readonly Language[]) => languages?.length ?? 0
);